import axios from "axios"
import { __constants } from "../constants"
import { createQuery } from "../utils"
const BASE_URL = process.env.REACT_APP_SERVER_URL

export const getDisputedInvoicesController = async (params = {}) => {
  try {
    // Build query string from params
    const queryString = createQuery(params)

    const config = {
      method: "GET",
      url: BASE_URL + `/v1/admin/invoices/disputes?limit=${params.limit || __constants.listingLimit}&${queryString}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(__constants.authToken)}`,
      },
    }
    const response = await axios(config)
    return response
  } catch (err) {
    console.error("Error in getDisputedInvoicesController >> ", err.message)
    return err.response
  }
}

export const resolveDisputeController = async (invoiceId, resolution) => {
  try {
    const config = {
      method: "PUT",
      url: BASE_URL + `/v1/admin/invoices/${invoiceId}/resolve`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(__constants.authToken)}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(resolution),
    }
    const response = await axios(config)
    return response
  } catch (err) {
    console.error("Error in resolveDisputeController >> ", err.message)
    return err.response
  }
}

export const getDisputeStatsController = async () => {
  try {
    const config = {
      method: "GET",
      url: BASE_URL + `/v1/admin/invoices/disputes/stats`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(__constants.authToken)}`,
      },
    }
    const response = await axios(config)
    return response
  } catch (err) {
    console.error("Error in getDisputeStatsController >> ", err.message)
    return err.response
  }
}
